import React from "react";
import {
  Box,
  Text,
  Textarea,
  HStack,
  Icon,
  VStack,
  useColorModeValue
} from "@chakra-ui/react";
import { FaInfoCircle } from "react-icons/fa";

const ContentTab = ({ settings, handleTextChange, accentColor }) => {
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <VStack spacing={6} align="stretch">
      <Box>
        <Text fontSize="sm" fontWeight="medium" mb={2}>First Message</Text>
        <Textarea
          placeholder="Enter the first message shown to users"
          value={settings.firstMessage || ""}
          onChange={(event) => handleTextChange(event, 'firstMessage')}
          size="sm"
          rows={3}
        />
      </Box>

      <Box>
        <Text fontSize="sm" fontWeight="medium" mb={2}>When Closed Message</Text>
        <Textarea
          placeholder="Message to show when widget is closed"
          value={settings.whenClosedMessage || ""}
          onChange={(event) => handleTextChange(event, 'whenClosedMessage')}
          size="sm"
          rows={3}
        />
      </Box>

      <Box p={3} bg="gray.50" borderRadius="md" borderLeft="4px solid" borderLeftColor={accentColor}>
        <HStack>
          <Icon as={FaInfoCircle} color={accentColor} />
          <Text fontSize="xs">
            These messages set the tone for your chat experience. Make them welcoming and clear.
          </Text>
        </HStack>
      </Box>
    </VStack>
  );
};

export default ContentTab;